// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Button from 'components/common/Button';
import Modal from 'components/common/Modal';

// COMPONENTS
import CreateSessionForm from 'components/forms/CreateSessionForm';
import SessionReminderForm from 'components/forms/SessionReminderForm';

export class SessionFormModal extends React.Component {
  state = {
    visible: this.props.visible || false,
    step: 1,
    session: null,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.visible !== this.props.visible) {
      this.setState({ visible: newProps.visible });
    }
  }

  toggleModal = () => {
    this.setState({
      visible: !this.state.visible,
      step: 1,
      session: null,
    });
  };

  onCompleteStep2 = () => {
    this.setState({
      session: null,
      visible: false,
      step: 1,
    });
  };

  onCompleteStep1 = newSession => {
    console.log({
      session: newSession,
      step: 2,
    });
    // this.setState({ visible: false });
    // TODO: add back step 2
    this.setState({
      session: newSession,
      step: 2,
    });
  };

  handleClick = evt => {
    evt.preventDefault();
    this.toggleModal();
  };

  render() {
    const { triggerType, clientId, buttonProps } = this.props;
    const { visible } = this.state;

    const text = 'NEW SESSION';

    const button = (
      <Button onClick={this.handleClick} {...buttonProps}>
        {text}
      </Button>
    );

    const anchor = (
      <a href="" onClick={this.handleClick} className="action-link">
        {text}
      </a>
    );

    let trigger = triggerType === 'button' ? button : anchor;

    if (this.props.trigger) {
      trigger = this.props.trigger();
    }

    return (
      <div className="inline">
        {trigger}
        <Modal
          title={this.state.step === 1 ? 'Add a Session' : 'Send Reminder?'}
          visible={visible}
          onOk={() => console.log('helpModalOpen')}
          onCancel={this.toggleModal}
          footer={null}
        >
          <div className="flex justify-center items-center">
            {this.state.step === 1 && (
              <CreateSessionForm
                hideClientInput
                clientId={clientId}
                currentUser={this.props.currentUser}
                sessionTypes={this.props.sessionTypes}
                onCancel={this.toggleModal}
                onComplete={this.onCompleteStep1}
              />
            )}
            {this.state.step === 2 && (
              <SessionReminderForm onCancel={this.toggleModal} onComplete={this.onCompleteStep2} />
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

SessionFormModal.propTypes = {
  clientId: PropTypes.string.isRequired,
  buttonProps: PropTypes.object, // eslint-disable-line
};

SessionFormModal.defaultProps = {
  buttonProps: {},
};

export default SessionFormModal;



// WEBPACK FOOTER //
// ./src/components/common/SessionFormModal/index.js